export default "__VITE_ASSET__dkzoMGsk__"